import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

import Tooltip from '../builder/Tooltip';

import LabelSelector from '../labels/LabelSelector';
import RibbonCollection from '../ui_items/RibbonCollection.js';

const ActiveLabelsDisplay = ({ labels, organizers, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const has_organizer = props?.has_organizer ?? false;

	const is_agent_admin = props?.is_agent_admin ?? false;
	const shared_with_me = props?.shared_with_me ?? false;

	let can_edit_label_selector = true;
	if(!is_agent_admin) {
		const search_labelSelector = organizers.find((obj) => (obj.id == (props?.label_item?.label_id ?? '')));
		if(!search_labelSelector) can_edit_label_selector = false;
	}

	let items = [];
	(labels?.current ?? []).filter((l) => (l.type != '3')).map((pl) => {
		const is_facebook = (pl.type == '2') ? true : false;

		let color = null;
		let icon = null;
		if(is_facebook) {
			color = '--facebook-color';
			icon = 'ep-facebook';
		} else if(pl.bg_color) {
			color = pl.bg_color;
		}

		items.push({
			title:pl.name,
			autotranslate:false,
			color,
			icon,
		});
	});


	if(has_organizer) {
		if(shared_with_me) {
			items.push({
				title:<>{i18n("Organizing brand")}: <strong>{has_organizer.name}</strong></>,
				tooltip:<Tooltip position="top" with_icon={false}>Shared with me</Tooltip>,
				autotranslate:false,
				color:'lightgray',
				is_html:true,
			});
		} else if(can_edit_label_selector) {
			items.push({
				title:<>{i18n("Organizer")}: <strong>{has_organizer.name}</strong></>,
				tooltip:<Tooltip position="top" with_icon={false}>Click here to change the organizing brand</Tooltip>,
				autotranslate:false,
				onClick:() => props.setDisplayLabelSelector(true),
				icon:'knk-edit',
				color:'lightgray',
				is_html:true,
			});
		} else {
			items.push({
				title:<>{i18n("Organizing brand")}: <strong>{has_organizer.name}</strong></>,
				tooltip:<Tooltip position="top" with_icon={false}>You can't change the organizing brand</Tooltip>,
				autotranslate:false,
				color:'lightgray',
				is_html:true,
			});
		}
	} else if(!shared_with_me) {
		items.push({
			title:<>{i18n("Organizer")}: <strong>{i18n("Not assigned")}</strong></>,
			tooltip:<Tooltip position="top" with_icon={false}>Click here to add an organizer</Tooltip>,
			autotranslate:false,
			onClick:() => props.setDisplayLabelSelector(true),
			icon:'ep-exclamation',
			color:'orange',
			is_html:true,
		});
	}

	return (
		<RibbonCollection
			items={items}
			paint_wrapper={props.paint_wrapper}
		/>
	)
};

const PromoLabelsManager = (props) => {
	const [ display_label_selector, setDisplayLabelSelector ] = useState(false);

	const [ organizers, setOrganizers ] = useState(props.organizers);
	const [ labels, setLabels ] = useState(props?.promo_labels ?? []);
	
	const [ has_organizer, setHasOrganizer ] = useState((labels.current && organizers) ? labels.current.find((obj) => (obj.type == 3)) : false);
	const promotion_id = props?.promotion_id ?? false;

	const label_item = (has_organizer) ? { label_id:has_organizer.id, promotion_id } : { promotion_id };

	const setLabelToPromotion = (label) => {
		if(label != undefined) {
			const label_current = labels.current.find((obj) => (obj.type == 3));

			let _labels = { ...labels };
			if(label_current != undefined && label_current.label_id != label.id) {
				const key_current = labels.current.indexOf(label_current);
				_labels.current.splice(key_current, 1);
				_labels.available = labels.available.concat(label_current);
			}
			_labels.current = _labels.current.concat(label);
			setLabels(_labels);

			const label_exist = organizers.find((obj) => (obj.id == label.id));
			if(!label_exist){
				setOrganizers([...organizers, label]);
			}
			setHasOrganizer(label);
		}

		setDisplayLabelSelector(false);
	};

	return (
		<>
			<ActiveLabelsDisplay
				//labels={labels}
				organizers={organizers}
				has_organizer={has_organizer}
				setDisplayLabelSelector={setDisplayLabelSelector}
				is_agent_admin={props?.is_agent_admin ?? false}
				shared_with_me={props.shared_with_me}
				paint_wrapper={props.paint_wrapper}
				intl={props.intl}
				label_item={label_item}
			/>

			{(display_label_selector) && (
				<LabelSelector
					callback_set_label={setLabelToPromotion}
					display_on='layer'
					type="3"
					item_to_assign={label_item}
					organizers={organizers}
					is_agent_admin={props?.is_agent_admin ?? false}
					onClose={()=>setDisplayLabelSelector(false)}
				/>
			)}
		</>
	)
}

export default injectIntl(PromoLabelsManager);